<template>
  
  <div class="padTSM moOnly pf23-lineBtm" >
    <!-- 안전확인 - mo 공동사업자 1, 모바일인 경우만 노출된다. PC 인 경우는 표시되지 않음-->
    <template v-if="sqCode == 'Q119'">
      <p class="fntP">안전 확인<span class="ico-must-astar"></span></p>
      <p class="fntP padTSM ">‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)</p>

      <div class="pf23-inFo-safe-L marTSM">
        <div class="amway-theme" style="width:55%;">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus" :id="`Q119-${seq}-FO`">
              <input type="radio" name="radio01-4" class="amw-global-radio" value="Y" 
                @change="inputRadioAnswer(`${seq}`, 'Q119', 'Y')" 
                :checked="participant.questions['Q119'].raw_data === 'Y'"
                :disabled="disabled">
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">예</span>
            </label>
            <label class="amw-radio-wrap radio-label focus" style="margin-right:1.5em;">
              <input type="radio" name="radio01-4" class="amw-global-radio" value="N" 
                @change="inputRadioAnswer(`${seq}`, 'Q119', 'N')" 
                :checked="participant.questions['Q119'].raw_data === 'N'"
                :disabled="disabled">
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">아니오</span>
            </label>
          </div>
        </div>
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에
        작성하여 주시기 바랍니다.</p>
    </template>
    <!-- //안전 확인 -->


    <template v-if="sqCode == 'Q120'">
      <p class="fntP">알러지 및 식단 확인</p>
      <p class="fntP padTSM ">알러지 또는 유의해야할 식단이 있습니까? 있다면 어떤 것인지 적어주십시오.</p>
      <div class="pf23-ipE marTSM">
        <label for="pf23answer01" class="fntP" style="display: none;">알러지 및 식단 답변</label>
        <input type="text" id="pf23answer01" class="widM ip-Max" name="pf23answer01" maxlength="30"
          :value="participant.questions[sqCode].raw_data"
          :disabled="disabled"
          @input="inputAnyAnswer(seq, sqCode, $event.target)"
        >
      </div>
    </template>

    <template v-if="sqCode == 'Q121'">
      <p class="fntP">VISA 발급 여부 <span class="ico-must-astar"></span></p>
      <p class="fntP padTSM ">ETA(전자여행허가)를 신청하셨습니까?</p>
      <div class="">
        <div class="pf23-ipE">
          <label :for="`Q121-${seq}-FO`"  class="fntP" style="display: none;">답변</label>
          <div class="pf23-inFo-safe">
            <div class="amway-theme" style="width:55%;">
              <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
                <label class="amw-radio-wrap radio-label focus">
                  <input type="radio"
                    :id="`Q121-${seq}-FO`"
                    :name="`visa-eta-radio-04`"
                    class="amw-global-radio"
                    value="Y"
                    @change="inputVisaEtaAnswer(`${seq}`, sqCode, 'Y')"
                    :checked="participant.questions[sqCode].raw_data === 'Y'"
                    :disabled="disabled"
                  >
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">예</span>
                </label>
                <label class="amw-radio-wrap radio-label focus">
                  <input type="radio" 
                    :name="`visa-eta-radio-04`"
                    class="amw-global-radio"
                    value="N"
                    @change="inputVisaEtaAnswer(`${seq}`, sqCode, 'N')"
                    :checked="participant.questions[sqCode].raw_data === 'N'"
                    :disabled="disabled"
                  >
                  <span class="amw-radio-overlay"></span>
                  <span class="amw-label-radio-text">아니오</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <template v-if="participant.questions[sqCode].raw_data == 'Y'" >
          <div class="pf23-visa-wrap inFo-L" v-if="participant.questions[sqCode].raw_data == 'Y'">
            <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common">
              <label :for="`Q122-${seq}-O`" class="fntP">비자 번호<span class="ico-must-astar"></span><br>(Visa Grant Number)
              </label>
              <input type="text"  maxlength='13'
                :id="`Q122-${seq}-O`"
                :name="`pf23visNum01-${seq}`" 
                :class="isRequired && (participant.questions['Q122'].hasError && participant.questions['Q122'].raw_data) ? 'check-red' : ''"
                :value="participant.questions['Q122'].raw_data"
                :disabled="disabled"
                @input="inputVisaNumberAnswer(seq, 'Q122', $event.target)"
              >
            </div>
            <p v-if="isRequired && (participant.questions['Q122'].hasError && participant.questions['Q122'].raw_data)" class="marTS fntE padBSM" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫  Visa 번호 13자리를 모두 입력해주세요.</p>

            <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common" v-if="participant.questions[sqCode].raw_data == 'Y'">
              <p class="fntP">비자 유효기간 <span class="ico-must-astar"></span><br>(Visa Expiry Date)</p>
              <div class="pf23-inFo-select pf23-date">
                <input
                  type="date"
                  :id="`Q123-${seq}-FO`"
                  :name="`NCAcmi_visa_expired_date${seq}`" 
                  style="width:100%"
                  class="NCAcmi_num"
                  :class="hint && participant.questions['Q123'].hasError ? 'check-red' : ''"
                  :value="participant.questions['Q123'].raw_data"
                  @change="inputVisaEtaDateAnswer(seq, 'Q123', $event.target);"
                  size="50"
                  maxlength="50"
                  :disabled="disabled"
                  :min="today"
                />
              </div>
            </div>
            <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="isRequired && hint && participant.questions['Q123'].hasError">🚫 최근 10년 이전까지만 선택 가능합니다.</template></p>
            
          </div>
          <p class="marTS fntE padBSM" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* AustrailanETA앱의 Visa Status &gt; Visa details에서 확인 가능합니다.</p>
          
        </template>
        <p class="marTS fntP padBSM"><a href="https://www.youtube.com/watch?v=wFp2yij2uUA&ab_channel=호뚜루뉴뚜루" style="color: #0075a4; font-weight: 500;" target="_blank">* <u>ETA 신청방법 확인하기 &gt;</u></a></p>        
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import {
  SURVEY_SYDNEY,
  GET_CODE_PASSPORT_DATE,
  GET_CODE_TODAY,
} from '@/store/actions/survey'

export default {
  name: 'SurveyParticipantFloatLeftOnly',
  mixins: [CommonMethodMixin],
  props: {
    participant: {
      type: Object,
      required: true
    },
    disabled: { 
      type: Boolean, 
      required: true
    },
    seq: { 
      type: Number, 
      required: true
    },
    sqCode: { 
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      hint: state => state.hint
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      passportDate: GET_CODE_PASSPORT_DATE,
      today: GET_CODE_TODAY,
    }),

  },
}
</script>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyParticipantFloatLeftOnly.vue